import { Controller } from "@hotwired/stimulus"

const createFeedbackDiv = (content = '&nbsp;', positive = false) =>
  `<div class="h-6 ${positive ? 'text-content-positive' : 'text-content-secondary'}">${content}</div>`

export default class extends Controller {
  static targets = ["feedback", "input"]

  static values = {
    idealLength: { type: Number, default: 0 },
    feedbackData: { type: Object, default: {} },
    word: { type: String, default: 'word' },
    words: { type: String, default: 'words' }
  }

  connect() {
    this.feedbackTarget.innerHTML = createFeedbackDiv()
    this.updateFeedback()
  }

  updateFeedback() {
    if (this.idealLengthValue <= 1) {
      this.feedbackTarget.innerHTML = createFeedbackDiv()
      return
    }

    const wordCount = this.getWordCount()


    if (wordCount === 0) {
      this.feedbackTarget.innerHTML = createFeedbackDiv()
      return
    }

    const percentage = (wordCount / this.idealLengthValue) * 100.0
    const feedback = this.getFeedback(percentage)

    if (feedback && feedback.selectedMessage) {
      const wordCountText = `${wordCount} ${wordCount === 1 ? this.wordValue : this.wordsValue}`

      this.feedbackTarget.innerHTML = `
        ${createFeedbackDiv(feedback.selectedMessage, feedback.threshold >= 100)}
        ${createFeedbackDiv(wordCountText)}
      `
    } else {
      this.feedbackTarget.innerHTML = createFeedbackDiv()
    }
  }

  getFeedback(percentage) {
    return Object.values(this.feedbackDataValue)
      .sort((a, b) => b.threshold - a.threshold)
      .find(mapping => percentage >= mapping.threshold)
  }

  /**
   * Cleans up text by:
   * - Converting to lowercase
   * - Adding spaces around punctuation
   * - Removing repeated punctuation (e.g., "...", ",,,")
   * - Removing standalone punctuation
   * - Removing single letters except 'a' and 'i'
   */
  cleanText(text) {
    return text
      .toLowerCase()
      .replace(/([.,!?;:])/g, ' $1 ')
      .replace(/\s+/g, ' ')
      .replace(/([.,!?;:]){2,}/g, '$1')
      .replace(/(?<=\s)[.,!?;:](?=\s)/g, '')
      .replace(/^[.,!?;:]+|[.,!?;:]+$/g, '')
      .replace(/(?<=\s|^)(?![ai](?=\s|$))[a-z](?=\s|$)/g, '')
      .trim()
  }

  getWordCount() {
    const text = this.cleanText(this.inputTarget?.innerText)

    return text
      .split(/\s+/)
      .filter(word =>
        word.length > 0 &&
        /[a-z]/i.test(word)
      ).length
  }
}
